import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import InfoButtonComponent from './InfoButtonComponent';
import { borderShadowKeys, borderShadowMixin } from '../../mixins/border';
import { buttonCursorMixin } from '../../mixins/button';
import { omitProps } from '../../helpers/elements';
import { fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin } from '../../mixins/layout';
import { buttonResetStyle } from '../../tokens/button';
import { appearanceNoneStyle } from '../../tokens/appearance';
import { baseHighlightStyle } from '../../tokens/highlight';
const InfoButton = styled(omitProps((props, ref) => /*#__PURE__*/React.createElement(InfoButtonComponent, _extends({
  ref: ref
}, props)), [...borderShadowKeys, ...fullWidthKeys, ...fullHeightKeys]))`
  ${borderShadowMixin}
  ${buttonCursorMixin}
  ${buttonResetStyle}
  ${appearanceNoneStyle}
  ${fullWidthMixin}
  ${fullHeightMixin}
  ${baseHighlightStyle}
`;
export default InfoButton;